import React, { Component } from "react";
import mixpanel from "mixpanel-browser"

import axios from "axios";
import {
  emailRegex,
  encrypt,
  allRegex,
  mixPannelEvent
} from '../../../shared/helper.js'
import { Loader } from "../../common/loader/loader.jsx";
import {
  baseURL,
} from "../../../constants/applicationConstants.js";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// import cookies from "js-cookie"

import LoginPage from './login.jsx'

export class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        email: "",
        password: "",
      },
      isProcessing: false,
      formError: {},
      formSubmitButtonDisable: true,
      isLoading: false,
      isFirstTime: true
    };
  }



  componentDidMount = () => {

    const mixpanelDataLogin = {
      eventName: "clicked_login",
      data: {
        name: "clicked_login"
      }
    }
    mixPannelEvent(mixpanelDataLogin);
    const selectedType = this.props.match.params.type;

    // Check if user is already authenticated
    const isLogin = localStorage.getItem('auth');

    // If user is already authenticated, redirect to home page
    if (isLogin) {
      this.props.history.push("/");
      return; // Exit early to prevent further execution
    }

    // Validate the selected type parameter
    if (selectedType === "institute" || selectedType === "expert" || selectedType === "customer") {
      this.props.history.push(`/login/${selectedType}`);
    } else {
      this.props.history.push("/");
      return; // Exit early since invalid type
    }

    // Clear any existing authentication data
    localStorage.removeItem("instituteId");
    localStorage.removeItem("email");
    localStorage.removeItem("token");
    localStorage.removeItem("comingFrom");
    localStorage.removeItem("instLoginType");
    localStorage.removeItem("flowName");
    localStorage.removeItem("AdminFlow");
    localStorage.removeItem("flowType");
  }

  onInputChangeHandler = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (value) {
      if (!this.inputRegexValidation(name, value)) {
        this.setState(
          {
            formData: {
              ...this.state.formData,
              [name]: value,
            },
            formError: {
              ...this.state.formError,
              [name]: "regx",
            },
          },
          () => this.isFromSubmissionBlock()
        );
      } else {
        this.setState(
          {
            formData: {
              ...this.state.formData,
              [name]: value,
            },
            formError: {
              ...this.state.formError,
              [name]: "",
            },
          },
          () => this.isFromSubmissionBlock()
        );
      }
    } else {
      this.setState(
        {
          formData: {
            ...this.state.formData,
            [name]: value,
          },
          formError: {
            ...this.state.formError,
            [name]: "",
          },
        },
        () => this.isFromSubmissionBlock()
      );
    }
  };

  onTouchHandler = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (value === "") {
      this.setState({
        formError: {
          ...this.state.formError,
          [name]: "req",
        },
      });
    } else {
      if (!this.inputRegexValidation(name, value)) {
        this.setState({
          formError: {
            ...this.state.formError,
            [name]: "regx",
          },
        });
      }
    }
  };

  inputRegexValidation = (name, value) => {

    if (name === "email") {
      return emailRegex.test(value);
    }
    else {
      return allRegex.test(value)
    }
  };

  isFromSubmissionBlock = () => {
    let { email, password } = this.state.formData;
    if (email && password) {
      if (
        !this.inputRegexValidation("email", email)
        ||
        !this.inputRegexValidation("password", password)
      ) {
        this.setState({
          formSubmitButtonDisable: true,
        });
      } else {
        this.setState({
          formSubmitButtonDisable: false,
        });
      }
    } else {
      this.setState({
        formSubmitButtonDisable: true,
      });
    }
  };
  formSubmitHandler = (e) => {
    const selectedType = this.props.match.params.type;
    const loginSuccess = {
      eventName: "login_success",
      data: {
        name: "login_success"
      }
    }
    this.setState({
      isLoading: true
    })
    e.preventDefault();
    let data = {
      email: this.state.formData.email,
      password: encrypt(this.state.formData.password)

    };
    // institute
    if (selectedType === "institute") {

      axios.post(`${baseURL}/institute/login`, data).then((res) => {
        localStorage.setItem("resendOtpData", JSON.stringify(data))
        localStorage.setItem("otpValidateToken", JSON.stringify(res.data?.data?.tokenValidate));
        localStorage.setItem('flowName', 'institute')
        localStorage.setItem('flowType', 'institute')
        mixPannelEvent(loginSuccess)
        this.setState({
          isLoading: false
        })
        mixpanel.identify(res.data?.data?.email)
        mixpanel.people.set({
          '$name': res.data?.data?.firstName,
          '$email': res.data?.data?.email,
          // Add anything else about the user here
        });
        toast.success("Login OTP sent to you Email successfully");
        setTimeout(() => {
          this.props.history.push("/otpLogin");
        }, 2000)

      }).catch((res) => {
        toast.error(res?.response.data.error.message);
        mixPannelEvent({
          eventName: "login_failed",
          data: {
            name: res?.response.data.error.message
          }
        })
        this.setState({
          isLoading: false
        })
      })
    } else if (selectedType === "customer") {
      axios.post(`${baseURL}/customer/login`, data).then((res) => {
        localStorage.setItem("resendOtpData", JSON.stringify(data))
        mixpanel.identify(res.data?.data?.email)
        mixpanel.people.set({
          '$name': res.data?.data?.firstName,
          '$email': res.data?.data?.email,
          // Add anything else about the user here
        });
        localStorage.setItem("otpValidateToken", JSON.stringify(res.data?.data?.tokenValidate));
        mixPannelEvent(loginSuccess)

        localStorage.setItem('flowName', 'customer')
        localStorage.setItem('flowType', 'customer')


        this.setState({
          isLoading: false
        })

        toast.success("Login OTP sent to you Email successfully");
        setTimeout(() => {
          this.props.history.push("/otpLogin");
        }, 2000)

      }).catch((res) => {
        toast.error(res?.response.data.error.message);
        mixPannelEvent({
          eventName: "login_failed",
          data: {
            name: res?.response.data.error.message
          }
        })
        this.setState({
          isLoading: false
        })
      })
    } else {
      axios.post(`${baseURL}/expert/login`, data).then((res) => {
        localStorage.setItem("otpValidateToken", JSON.stringify(res.data?.data?.tokenValidate));
        mixpanel.identify(res.data?.data?.email)
        mixpanel.people.set({
          '$name': res.data?.data?.firstName,
          '$email': res.data?.data?.email,
          // Add anything else about the user here
        });
        localStorage.setItem("resendOtpData", JSON.stringify(data))
        localStorage.setItem('flowName', 'expert')
        localStorage.setItem('flowType', 'expert')
        mixPannelEvent(loginSuccess)

        this.setState({
          isLoading: false
        })

        toast.success("Login OTP sent to you Email successfully");
        setTimeout(() => {
          this.props.history.push("/otpLogin");
        }, 2000)


      }).catch((res) => {
        toast.error(res?.response.data.error.message);
        mixPannelEvent({
          eventName: "login_failed",
          data: {
            name: res?.response.data.error.message
          }
        })
        this.setState({
          isLoading: false
        })
      })
    }
  };

  onResendOTPClick = () => {
    const selectedType = this.props.match.params.type;

    let dataInstitute = {
      category: "institute",
      userType: "institute"
    }
    let dataCustomer = {
      category: "customer",
    }
    let dataExpert = {
      category: "expert",
    }
    let email = JSON.parse(localStorage.getItem("email"))
    this.setState({ isLoading: true });
    axios.post(`${baseURL}/forgotPassword/${email}/sendOTP`, selectedType === "institute" ? dataInstitute : selectedType === "expert" ? dataExpert : dataCustomer).then((res) => {
      localStorage.setItem("token", JSON.stringify(res.data?.data?.tokenValidate));
    }).catch((res) => {
      toast.error(res?.response.data.error.message);

      this.setState({ isLoading: false });
    })
  }

  onFirstLoginClick = () => {
    const selectedType = this.props.match.params.type;

    if (selectedType === "institute") {
      this.onFirstLoginClickInstitute()
    } else if (selectedType === "expert") {
      this.onFirstLoginClickExpert()
    } else {
      this.onFirstLoginClickCustomer()
    }
  }

  // institute
  onFirstLoginClickInstitute = () => {
    this.setState({
      isLoading: true
    })
    const loginStart = {
      eventName: "login_initiated",
      data: {
        name: "login_initiated"
      }
    }
    localStorage.removeItem("instLoginType");
    localStorage.removeItem("instUserId");
    axios.post(`${baseURL}/institute/${this.state.formData?.email}/existence`).then(res => {
      this.setState({
        isLoading: false
      })
      if (res) {
        mixPannelEvent(loginStart)
      }
      localStorage.setItem("instLoginType", res?.data?.data?.userType);
      if (res?.data?.data?.userType === 'institute_user') {
        localStorage.setItem("instUserId", res?.data?.data?.instituteUserId);
      }
      // checking start
      if (res.data.data.onboardingStep === 'subscription-paid' || res.data.data.onboardingStep === 'subscription-upgraded')
        this.setState({ isFirstTime: false });
      else {
        localStorage.setItem("email", JSON.stringify(this.state.formData?.email));
        localStorage.setItem('flowName', 'institutional')
        localStorage.setItem('flowType', 'institute')
        localStorage.setItem("comingFrom", "login")
        localStorage.setItem('AdminFlow', 'institute')

        localStorage.setItem("instituteId", JSON.stringify(res.data?.data?.instituteId));

        this.onResendOTPClick()
        this.props.history.push('./passwordAuth')
      }
      // checking end
    }).catch(err => {
      toast.error(err.response.data.error.message);
      this.setState({
        isLoading: false
      })
    })
  }

  // expert
  onFirstLoginClickExpert = () => {
    this.setState({
      isLoading: true
    })
    axios.post(`${baseURL}/expert/${this.state.formData?.email}/existence`).then(res => {
      this.setState({
        isLoading: false
      })
      // start
      if (res.data.data.onboardingStep === 'subscription-paid' || res.data.data.onboardingStep === 'subscription-upgraded')
        this.setState({ isFirstTime: false });
      else {
        localStorage.setItem("email", JSON.stringify(this.state.formData?.email));
        localStorage.setItem('flowName', 'expert')
        localStorage.setItem('flowType', 'expert')
        localStorage.setItem("comingFrom", "login")
        localStorage.setItem('AdminFlow', 'expert')
        localStorage.setItem("expertId", JSON.stringify(res.data?.data?.expertId));

        this.onResendOTPClick()
        this.props.history.push('./passwordAuth')
      }
      // end

    }).catch(err => {
      toast.error(err.response.data.error.message);
      this.setState({
        isLoading: false
      })
    })
  }

  // customer

  onFirstLoginClickCustomer = () => {
    this.setState({
      isLoading: true
    })
    axios.post(`${baseURL}/customer/${this.state.formData?.email}/existence`).then(res => {
      this.setState({
        isLoading: false
      })
      // res && localStorage.setItem("token", JSON.stringify(res.data?.data?.tokenValidate));


      this.setState({ isFirstTime: false });
      if (res.data.data.onboardingStep === 'basic-info' || res.data.data.onboardingStep === 'verify-otp') {
        localStorage.setItem("email", JSON.stringify(this.state.formData?.email));
        localStorage.setItem('flowName', 'customer')
        localStorage.setItem('flowType', 'customer')
        this.onResendOTPClick()
        this.props.history.push('/passwordAuth')
      }
    }).catch(err => {
      toast.error(err.response.data.error.message);
      this.setState({
        isLoading: false
      })
    })
  }


  render() {
    return (
      <div>
        <LoginPage
          formData={this.state.formData}
          onInputChangeHandler={this.onInputChangeHandler}
          onTouchHandler={this.onTouchHandler}
          formSubmitButtonDisable={this.state.formSubmitButtonDisable}
          formError={this.state.formError}
          formSubmitHandler={this.formSubmitHandler}
          isLoading={this.state.isLoading}
          isFirstTime={this.state.isFirstTime}
          onFirstLoginClick={this.onFirstLoginClick}
          selectedType={this.props.match.params.type}
        />
        {this.state.isLoading && <Loader />}
      </div>
    );
  }
}

export default Login;
